import React, { useContext, useState } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { modalCloseNextModalHandler } from '../Modal/utils';
import styles from './RPSPlansModal.css';

const RPSPlansModal = () => {
  const { appState, closeNextModal, next } = useContext(FlowContext);
  const {
    store: {
      loadedData: { rpsPlans }
    }
  } = appState;

  const rpsPlanNumbers = rpsPlans?.planNumbers;

  const [disableBtn, setDisableBtn] = useState(true);
  const [rpsPlanNumber, setRPSPlanNumber] = useState('');

  const routeToRPSFlow = async () => {
    await next({
      section: 'rpsPlansModal',
      rpsPlanNumber
    })();
  };

  const handleRPSPlan = ({ target: { value } }) => {
    setRPSPlanNumber(value);
    return setDisableBtn(false);
  };

  const rpsPlanOptions = rpsPlanNumbers?.map(plan => {
    return {
      title: plan,
      value: `${plan}`
    };
  });

  return (
    <div className="rps-plans-modal">
      <MFBeaconModal open removeCloseButton>
        <RadioGroupField
          title="Please choose the RPS plan the client wishes to roll assets from"
          options={rpsPlanOptions}
          onChange={handleRPSPlan}
          name="rpsPlanOptions"
        />

        <div className="rps-btn-container" slot="action-zone">
          <MFBeaconButton
            variant="primary"
            id="routeToRPSFlow"
            data-name="routeToRPSFlow"
            disabled={disableBtn}
            noButtonMargin
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
              routeToRPSFlow();
            }}
            label="Continue"
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSPlansModal;
